import { ReactNode } from 'react';
import { Tooltip } from 'mode-shared/components';
import { twMerge } from 'tailwind-merge';

export const SelectableOptionButton = ({
  label,
  value,
  onChange,
  selected,
  disabled,
  tooltip,
}: {
  label: ReactNode;
  value: string;
  onChange: (value: string) => void;
  selected: boolean;
  disabled?: boolean;
  tooltip?: string;
}) => {
  const buttonContent = (
    <button
      className={twMerge(
        'relative w-full h-full rounded-xl border-2 transition-all duration-200 font-semibold text-sm',
        'flex flex-col items-center justify-center gap-3 py-4 px-2',
        selected
          ? 'bg-primary/20 border-primary shadow-lg shadow-primary/20 scale-[1.02]'
          : 'bg-neutral-950/60 border-neutral-800 hover:border-neutral-700 hover:bg-neutral-950/80',
        disabled && 'opacity-50 pointer-events-none cursor-not-allowed'
      )}
      onClick={() => !disabled && onChange(value)}
      disabled={disabled}
    >
      <div className="flex flex-col items-center gap-3">{label}</div>
    </button>
  );

  if (tooltip) {
    return (
      <Tooltip align="center" side="top" trigger={buttonContent}>
        <div className="max-w-[160px]">{tooltip}</div>
      </Tooltip>
    );
  }

  if (disabled) {
    return (
      <Tooltip align="center" side="top" trigger={buttonContent}>
        Coming soon
      </Tooltip>
    );
  }

  return buttonContent;
};
